document.addEventListener("DOMContentLoaded", () => {
  const faq = document.getElementById("faq");

  if (faq) {
    const faqItems = faq.querySelectorAll("li");

    faqItems.forEach((item) => {
      const button = item.querySelector("button");

      button.addEventListener("click", () => {
        const isOpen = item.classList.contains("open");

        // Close all items
        faqItems.forEach((i) => i.classList.remove("open"));

        // Toggle the clicked item
        if (!isOpen) {
          item.classList.add("open");
        }
      });
    });
  }
});
